import React from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';

const headerStyle = {
  position: 'relative',
  zIndex: 1000,
  maxHeight: 'auto',
  height: 'auto',
  backgroundColor: '#0C2E42',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingLeft: '6%',
};

const linkStyle = {
  color: 'white',
  padding: '5px 15px',
  borderRadius: '5px',
  marginRight: '10px',
  textDecoration: 'none',
  backgroundColor: '#0C2E42',
};

const currentLinkStyle = {
  ...linkStyle,
  backgroundColor: 'black',
};

const Header = () => {
  const location = useLocation();

  return (
    <Navbar style={headerStyle} expand="lg">
      <Container>
        <Navbar.Brand>
          <Link to="/quiz-app">
            <img src="/quiz-app/logo192.png" alt="Logo" height="40" width="auto" />
          </Link>
        </Navbar.Brand>
        <h2>Quiz App</h2>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" style={{ justifyContent: 'right', marginRight: '10%' }}>
          <Nav className="ml-auto">
            <Link to="/quiz-app" style={location.pathname === '/quiz-app' ? currentLinkStyle : linkStyle}>
              Home
            </Link>
            <Link
              to="/quiz-app/take-quiz"
              style={location.pathname === '/quiz-app/take-quiz' ? currentLinkStyle : linkStyle}
            >
              Take Quiz
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
